import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { UserService } from '../services/user.service';
import { IncludesComponent } from '../includes/includes.component';
import { ProfileDataRecieveService } from '../services/user_data_recieve.service';
import { SpinnerService } from '../services/spinner';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  profile: any;
  email = '';
  data: any;
  disableButton = false;
  private waitSubject = new Subject<string>();
  userProfile = this.waitSubject.asObservable();

  constructor(private auth: AuthService, private userService: UserService, private router: Router,
    private dataRecieveService: ProfileDataRecieveService, private spinnerService: SpinnerService) {
    this.data = localStorage.getItem('user_data');
    if (this.profile && (this.data != null || this.data !== 'null')) {
      // do nothing
    } else {
      // this.router.navigateByUrl('home/user');
    }
  }

  ngOnInit() {
    this.dataRecieveService.get().subscribe(data => {
      const profile_text = localStorage.getItem('profile');
      if (profile_text != null) {
        const profile = JSON.parse(profile_text);
        this.profile = profile;
        this.email = profile.email;

        if (this.profile && (this.data == null || this.data === 'null')) {
          this.getUserData();
        } else {
          this.router.navigateByUrl('home/user');
        }
      }
    });
  }

  getUserData() {
    this.disableButton = true;
    this.spinnerService.show();
    this.userService.getCurrentUser(this.email).valueChanges.subscribe(({ data }: any) => {
      this.data = JSON.stringify(data.User);
      localStorage.setItem('user_data', this.data);
      this.disableButton = false;
      this.spinnerService.hide();
      this.router.navigateByUrl('home/user');
    }, (error) => {
      
    });
  }

  redirectToAdd() {
    if (this.auth.isAuthenticated()) {
      this.router.navigateByUrl('vision/home');
    } else {
      this.auth.locklogin();
    }
  }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/home/home.component.ts